"use client";

import { Toaster } from "@/components/ui/sonner";
import StytchProvider from "@/shared/auth/stytch-provider";
import { LayoutPreferenceContext } from "@/shared/providers/preferences-provider";
import { ThemeProvider } from "@/shared/providers/theme-provider";
import type React from "react";
import { BetaFeaturesProvider } from "./beta-features-provider";

export const ClientProviders = ({
  children,
  layoutPreferences,
}: {
  children: React.ReactNode;
  // biome-ignore lint: no-any
  layoutPreferences: any;
}) => {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <BetaFeaturesProvider>
        <LayoutPreferenceContext.Provider value={{ layoutPreferences }}>
          <StytchProvider>
            {children}
            <Toaster richColors />
          </StytchProvider>
        </LayoutPreferenceContext.Provider>
      </BetaFeaturesProvider>
    </ThemeProvider>
  );
};
